import { render, staticRenderFns } from "./GetProjectInfo.vue?vue&type=template&id=154585ca&scoped=true"
import script from "./GetProjectInfo.vue?vue&type=script&lang=js"
export * from "./GetProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./GetProjectInfo.vue?vue&type=style&index=0&id=154585ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154585ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDatePicker,VFlex,VForm,VLayout,VMenu,VTextField,VTextarea})
